import _ from 'lodash';

import { ikeaUrl } from 'utils/utils';

export default function findImage(item, size, conditions, index = 0) {
  if (item.RetailItemImageList && item.RetailItemImageList.RetailItemImage) {
    const imageData = item.RetailItemImageList.RetailItemImage.filter((image) => {
      return image.ImageSize === size && _.toPairs(conditions).every(([key, value]) => value === image[key]);
    }).sort((i1, i2) => i1.SortNo - i2.SortNo);

    if (imageData.length > 0) {
      const image = imageData[Math.min(imageData.length - 1, index)];

      return image && ikeaUrl(image.ImageUrl);
    }

    // temporary solution for ceramic wallpanel expression images, can be removed in future
    else if(item.ProductName === 'EKEKULL'){
      const ceramicImageData = item.RetailItemImageList.RetailItemImage.filter((image) => {
        return image.ImageSize === size;
      }).sort((i1, i2) => i1.SortNo - i2.SortNo);
      const image = ceramicImageData[Math.min(ceramicImageData.length - 1, index)];
      return image && ikeaUrl(image.ImageUrl);
    } 
  }

  return '';
}

export function findImagesS5(item, size) {
  if (item.RetailItemImageList && item.RetailItemImageList.RetailItemImage) {
    const imageData = item.RetailItemImageList.RetailItemImage.filter((image) => {
      return image.ImageSize === size;
    }).sort((i1, i2) => i1.SortNo - i2.SortNo);

    return imageData.map(image => ikeaUrl(image.ImageUrl));
  }

  return [];
}
